import React from 'react';
import { TransitionGroup } from 'react-transition-group';
import classNames from 'classnames';

import TransitionHandler from './TransitionHandler';
import css from './CardTransition.scss';

type Props = {
	data: {
		_id?: string;
	};
	className?: string;
};

export default class CardTransition extends React.PureComponent<Props> {
	static defaultProps = {
		className: '',
		children: null,
	};

	render() {
		const { className, data, children } = this.props;

		return (
			<TransitionGroup className={classNames(css.transition, className)} appear enter exit>
				<TransitionHandler key={data._id}>{children}</TransitionHandler>
			</TransitionGroup>
		);
	}
}

export { CardTransitionContext } from './TransitionHandler';
